import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {isBeaches} from 'js/modules/brand';

class MenuContent extends Component {

  render() {
    const { className } = this.props;
    const _navbarGrid = isBeaches ? 'md-8' : 'md-6';

    return (
      <div className={`nav-content scrollable-lg sm-12 ${_navbarGrid} lg-9 ${className}`}>
        {this.props.children}
      </div>
    );
  }
}

MenuContent.propTypes = {
  className: PropTypes.string,
};

MenuContent.defaultValue = {
  className: '',
};

export default MenuContent;



// WEBPACK FOOTER //
// ./js/components/global/menu/MenuContent.js